import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'auth.change.newPasswordLabel': 'New Password',
  'auth.change.newPasswordPlaceholder': 'Enter new password',
  'auth.change.subtitle': 'Set new password',
  'auth.change.title': 'Change password',
  'auth.change.verificationCode': 'Verification code',
  'auth.code.label': 'Code',
  'auth.confirm.backSignup': 'Back to sign up',
  'auth.confirm.resend': 'Resend code',
  'auth.confirm.resendFew': 'Resend in {count} seconds',
  'auth.confirm.resendMany': 'Resend in {count} seconds',
  'auth.confirm.resendOne': 'Resend in {count} second',
  'auth.confirm.resendOther': 'Resend in {count} seconds',
  'auth.confirm.submit': 'Confirm email',
  'auth.confirm.subtitle':
    'We sent an email with a code to {email}. Copy the code from the email and paste it into the form to confirm your account.',
  'auth.confirm.title': 'Confirm your email',
  'auth.confirmationCodeSent': 'A confirmation code was sent to your email',
  'auth.email.label': 'Email',
  'auth.email.placeholder': 'Enter your email',
  'auth.error.emailValidationFailed': 'Email validation failed',
  'auth.error.incorrectEmail': 'Enter a valid email address',
  'auth.error.incorrectPassword': 'Incorrect password',

  'auth.error.passwordTooShort': 'At least 6 characters',
  'auth.error.somethingWentWrong': 'Something went wrong',
  'auth.error.temporaryEmail': 'Please use a non-temporary email address',
  'auth.forgot.backSignin': 'Back to Sign in',
  'auth.forgot.confirm': 'Confirm',
  'auth.forgot.subtitle': 'Enter your email address and we will send you instructions on how to reset your password.',
  'auth.forgot.title': 'Forgot Your Password?',
  'auth.google.signin': 'Sign in with Google',
  'auth.google.signup': 'Sign in with Google',
  'auth.info.achievementsAlt': 'Rask AI awards and ratings',
  'auth.info.editorAlt': 'Rask AI video editor interface',
  'auth.info.feature.captions': 'AI-generated captions',
  'auth.info.feature.dictionary': 'Translation dictionary',
  'auth.info.feature.languages': 'Translation into 135+ supported languages',
  'auth.info.feature.lipSync': 'Lip-Sync for best-in-class localization',
  'auth.info.feature.multiSpeaker': 'Multi-speaker dubbing support',
  'auth.info.feature.voiceClone': 'Voice Clone in 32 languages',
  'auth.info.featuresTitleBottom': 'for high-quality results',
  'auth.info.featuresTitleTop': 'Best features',
  'auth.info.review.enterpriseRole': 'Mentor, Enterprise',
  'auth.info.review.enterpriseText': 'Great tool for translating educational videos!',
  'auth.info.review.startupRole': 'Startup',
  'auth.info.review.startupText': 'Best tool for dubbing and translating',
  'auth.info.scaleTitleBottom': 'translation at scale',
  'auth.info.scaleTitleTop': 'Intelligent video',
  'auth.info.usersTitleBottom': 'our video translation AI',
  'auth.info.usersTitleTop': '2,000,000+ users trust',
  'auth.landing.createAccount': 'Create a free account to translate it for free.',
  'auth.landing.fileUploaded': 'Your file is already uploaded!',
  'auth.landing.hasAccount': 'Do you have an account?',
  'auth.landing.marketingConsent':
    "We'll send you product updates, tips and offers from Rask.ai. You can unsubscribe at any time.",
  'auth.landing.orEmail': 'Or sign up with email',
  'auth.landing.signIn': 'Sign in',
  'auth.landing.signUpFree': 'Sign up free',
  'auth.landing.uploadComplete': 'Upload complete',
  'auth.password.label': 'Password',
  'auth.passwordResetNotice': 'Please update your password. We sent a confirmation code to your email.',
  'auth.signin.forgotPassword': 'Forgot password?',
  'auth.signin.noAccount': "Don't have an account?",
  'auth.signin.subtitle': 'Continue translating your videos 🤘',
  'auth.signin.title': 'Sign in',
  'auth.signup.landingSubtitle': 'Create a free account to watch it.',
  'auth.signup.landingTitle': 'Your translated video is almost ready!',
  'auth.signup.submit': 'Sign up',
  'auth.signup.subtitle': 'Join 2M+ users translating videos in minutes with AI',
  'auth.signup.welcome': 'Welcome',
  'auth.signup.welcomeRask': 'Welcome to Rask AI',
  'auth.signupExperiment.adminEnabled': 'Enable signup experiment',
  'auth.signupExperiment.brandTone': 'Consistent brand & tone',
  'auth.signupExperiment.cleanSubtitle': 'Join 4M+ users translating videos with AI',
  'auth.signupExperiment.company': 'Using a company account?',
  'auth.signupExperiment.createPassword': 'Create password',
  'auth.signupExperiment.emailSubmit': 'Sign up with email',
  'auth.signupExperiment.fiveStars': '5 out of 5 stars',
  'auth.signupExperiment.languages': '135+ languages',
  'auth.signupExperiment.noCard': 'No credit card required',
  'auth.signupExperiment.orEmail': 'or with email',
  'auth.signupExperiment.publishReady': 'Publish-ready videos',
  'auth.signupExperiment.rating': 'Rated {rating} out of 5 on G2',
  'auth.signupExperiment.reviewOne':
    '“We localize our entire training library into 12 languages, and every video still sounds like us.”',
  'auth.signupExperiment.reviewTwo':
    '“The voice clone sold it. I record once and publish in four languages without hiring four actors.”',
  'auth.signupExperiment.richTitle': 'Translate Your First Video',
  'auth.signupExperiment.roleOne': 'Head of Content Operations',
  'auth.signupExperiment.roleTwo': 'L&D Specialist',
  'auth.signupExperiment.startFree': 'Start free',
  'auth.signupExperiment.teams': 'Used by global teams',
  'auth.signupExperiment.trustTitle': '4,000,000+ Users Trust Rask with AI Video Localization',
  'auth.signupExperiment.voiceClone': 'Voice clone',
  'auth.sso.back': 'Go back',
  'auth.sso.continue': 'Continue',
  'auth.sso.continueEmail': 'Continue with email and password',
  'auth.sso.notConfigured': 'SSO is not configured for your email',
  'auth.sso.signin': 'Sign in with SSO',
  'auth.sso.signup': 'Sign in with SSO',
  'auth.sso.subtitle': 'Use your company email to sign in',
  'auth.sso.title': 'Continue with SSO',
  'auth.terms.and': '&',
  'auth.terms.prefix': "By signing up, you agree to Rask's",
  'auth.terms.privacy': 'Privacy Policy',
  'auth.terms.service': 'Terms of Service',
} as const;

type AuthTranslation = Record<keyof typeof en, string>;

const es = {
  'auth.change.newPasswordLabel': 'Nueva contraseña',
  'auth.change.newPasswordPlaceholder': 'Introduce una nueva contraseña',
  'auth.change.subtitle': 'Establece una nueva contraseña',
  'auth.change.title': 'Cambiar contraseña',
  'auth.change.verificationCode': 'Código de verificación',
  'auth.code.label': 'Código',
  'auth.confirm.backSignup': 'Volver a registrarse',
  'auth.confirm.resend': 'Reenviar código',
  'auth.confirm.resendFew': 'Reenviar en {count} segundos',
  'auth.confirm.resendMany': 'Reenviar en {count} segundos',
  'auth.confirm.resendOne': 'Reenviar en {count} segundo',
  'auth.confirm.resendOther': 'Reenviar en {count} segundos',
  'auth.confirm.submit': 'Confirmar correo electrónico',
  'auth.confirm.subtitle':
    'Hemos enviado un correo electrónico con un código a {email}. Copia el código del correo y pégalo en el formulario para confirmar tu cuenta.',
  'auth.confirm.title': 'Confirma tu correo electrónico',
  'auth.confirmationCodeSent': 'Hemos enviado un código de confirmación a tu correo electrónico',
  'auth.email.label': 'Correo electrónico',
  'auth.email.placeholder': 'Introduce tu correo electrónico',
  'auth.error.emailValidationFailed': 'No se ha podido validar el correo electrónico',
  'auth.error.incorrectEmail': 'Correo electrónico incorrecto',
  'auth.error.incorrectPassword': 'Contraseña incorrecta',

  'auth.error.passwordTooShort': 'Al menos 6 caracteres',
  'auth.error.somethingWentWrong': 'Algo salió mal',
  'auth.error.temporaryEmail': 'Utiliza una dirección de correo electrónico que no sea temporal',
  'auth.forgot.backSignin': 'Volver a iniciar sesión',
  'auth.forgot.confirm': 'Confirmar',
  'auth.forgot.subtitle':
    'Introduce tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.',
  'auth.forgot.title': '¿Has olvidado tu contraseña?',
  'auth.google.signin': 'Iniciar sesión con Google',
  'auth.google.signup': 'Iniciar sesión con Google',
  'auth.info.achievementsAlt': 'información sobre logros',
  'auth.info.editorAlt': 'información del editor',
  'auth.info.feature.captions': 'Subtítulos generados por IA',
  'auth.info.feature.dictionary': 'Diccionario de traducción',
  'auth.info.feature.languages': 'Traducción a más de 135 idiomas',
  'auth.info.feature.lipSync': 'Lip-sync para una adaptación de primer nivel',
  'auth.info.feature.multiSpeaker': 'Doblaje con varios hablantes',
  'auth.info.feature.voiceClone': 'Clonación de voz en 32 idiomas',
  'auth.info.featuresTitleBottom': 'para obtener resultados de alta calidad',
  'auth.info.featuresTitleTop': 'Las mejores funciones',
  'auth.info.review.enterpriseRole': 'Mentora, Enterprise',

  'auth.info.review.enterpriseText': '¡Una herramienta excelente para traducir vídeos educativos!',
  'auth.info.review.startupRole': 'Startup ',
  'auth.info.review.startupText': 'La mejor herramienta para doblar y traducir',
  'auth.info.scaleTitleBottom': 'a gran escala',
  'auth.info.scaleTitleTop': 'Traducción inteligente de vídeo',
  'auth.info.usersTitleBottom': 'en nuestra IA de traducción de vídeo',
  'auth.info.usersTitleTop': 'Más de 2 000 000 de usuarios confían',
  'auth.landing.createAccount': 'Crea una cuenta gratuita para traducirlo sin coste.',
  'auth.landing.fileUploaded': '¡Tu archivo ya está subido!',
  'auth.landing.hasAccount': '¿Ya tienes una cuenta?',
  'auth.landing.marketingConsent':
    'Te enviaremos novedades del producto, consejos y ofertas de Rask.ai. Puedes darte de baja en cualquier momento.',
  'auth.landing.orEmail': 'O regístrate con tu correo electrónico',
  'auth.landing.signIn': 'Iniciar sesión',
  'auth.landing.signUpFree': 'Registrarse gratis',
  'auth.landing.uploadComplete': 'Carga completada',
  'auth.password.label': 'Contraseña',
  'auth.passwordResetNotice':
    'Actualiza tu contraseña. Hemos enviado un código de confirmación a tu correo electrónico.',
  'auth.signin.forgotPassword': '¿Has olvidado tu contraseña?',
  'auth.signin.noAccount': '¿No tienes una cuenta?',
  'auth.signin.subtitle': 'Sigue traduciendo vídeos 🤘',
  'auth.signin.title': 'Iniciar sesión',
  'auth.signup.landingSubtitle': 'Crea una cuenta gratuita para verlo.',
  'auth.signup.landingTitle': '¡Tu vídeo traducido está casi listo!',
  'auth.signup.submit': 'Registrarse',
  'auth.signup.subtitle': 'Únete a más de 2 M de usuarios y traduce cualquier vídeo con IA en minutos',
  'auth.signup.welcome': 'Te damos la bienvenida',
  'auth.signup.welcomeRask': 'Te damos la bienvenida a Rask AI',
  'auth.signupExperiment.adminEnabled': "Activar el experimento de registro",
  'auth.signupExperiment.brandTone': 'Identidad y tono de marca coherentes',
  'auth.signupExperiment.cleanSubtitle': 'Únete a más de 4 millones de usuarios que traducen vídeos con IA',
  'auth.signupExperiment.company': '¿Usas una cuenta de empresa?',
  'auth.signupExperiment.createPassword': 'Crea una contraseña',
  'auth.signupExperiment.emailSubmit': 'Regístrate con tu correo',
  'auth.signupExperiment.fiveStars': '5 de 5 estrellas',
  'auth.signupExperiment.languages': 'Más de 135 idiomas',
  'auth.signupExperiment.noCard': 'No necesitas tarjeta de crédito',
  'auth.signupExperiment.orEmail': 'o con tu correo',
  'auth.signupExperiment.publishReady': 'Vídeos listos para publicar',
  'auth.signupExperiment.rating': 'Valoración de {rating} sobre 5 en G2',
  'auth.signupExperiment.reviewOne':
    '“Localizamos toda nuestra biblioteca de formación en 12 idiomas y cada vídeo sigue sonando como nosotros.”',
  'auth.signupExperiment.reviewTwo':
    '“La clonación de voz me convenció. Grabo una sola vez y publico en cuatro idiomas sin contratar a cuatro actores.”',
  'auth.signupExperiment.richTitle': 'Traduce tu primer vídeo',
  'auth.signupExperiment.roleOne': 'Responsable de Operaciones de Contenido',
  'auth.signupExperiment.roleTwo': 'Especialista en Formación y Desarrollo',
  'auth.signupExperiment.startFree': 'Empieza gratis',
  'auth.signupExperiment.teams': 'Utilizado por equipos de todo el mundo',
  'auth.signupExperiment.trustTitle': 'Más de 4.000.000 de usuarios confían en Rask para localizar vídeos con IA',
  'auth.signupExperiment.voiceClone': 'Clonación de voz',
  'auth.sso.back': 'Volver',
  'auth.sso.continue': 'Continuar',
  'auth.sso.continueEmail': 'Continuar con correo electrónico y contraseña',
  'auth.sso.notConfigured': 'El SSO no está configurado para tu correo electrónico',
  'auth.sso.signin': 'Iniciar sesión con SSO',
  'auth.sso.signup': 'Iniciar sesión con SSO',
  'auth.sso.subtitle': 'Usa el correo electrónico de tu empresa para iniciar sesión',
  'auth.sso.title': 'Continuar con SSO',
  'auth.terms.and': 'y las',
  'auth.terms.prefix': 'Al registrarte, aceptas la',
  'auth.terms.privacy': 'Política de privacidad',
  'auth.terms.service': 'Condiciones del servicio',
} satisfies AuthTranslation;

const pt = {
  'auth.change.newPasswordLabel': 'Nova senha',
  'auth.change.newPasswordPlaceholder': 'Digite a nova senha',
  'auth.change.subtitle': 'Defina uma nova senha',
  'auth.change.title': 'Alterar senha',
  'auth.change.verificationCode': 'Código de verificação',
  'auth.code.label': 'Código',
  'auth.confirm.backSignup': 'Voltar ao cadastro',
  'auth.confirm.resend': 'Reenviar código',
  'auth.confirm.resendFew': 'Reenviar em {count} segundos',
  'auth.confirm.resendMany': 'Reenviar em {count} segundos',
  'auth.confirm.resendOne': 'Reenviar em {count} segundo',
  'auth.confirm.resendOther': 'Reenviar em {count} segundos',
  'auth.confirm.submit': 'Confirmar e-mail',
  'auth.confirm.subtitle':
    'Enviamos um e-mail com um código para {email}. Copie o código do e-mail e introduza-o no formulário para confirmar a sua conta.',
  'auth.confirm.title': 'Confirme seu e-mail',
  'auth.confirmationCodeSent': 'Enviamos um código de confirmação para o seu e-mail',
  'auth.email.label': 'E-mail',
  'auth.email.placeholder': 'Digite seu e-mail',
  'auth.error.emailValidationFailed': 'Falha na validação do e-mail',
  'auth.error.incorrectEmail': 'E-mail incorreto',
  'auth.error.incorrectPassword': 'Senha incorreta',

  'auth.error.passwordTooShort': 'Pelo menos 6 caracteres',
  'auth.error.somethingWentWrong': 'Algo deu errado',
  'auth.error.temporaryEmail': 'Use um endereço de e-mail que não seja temporário',
  'auth.forgot.backSignin': 'Voltar para o login',
  'auth.forgot.confirm': 'Confirmar',
  'auth.forgot.subtitle': 'Digite seu endereço de e-mail e enviaremos instruções para redefinir sua senha.',
  'auth.forgot.title': 'Esqueceu sua senha?',
  'auth.google.signin': 'Entrar com o Google',
  'auth.google.signup': 'Entrar com o Google',
  'auth.info.achievementsAlt': 'informações sobre conquistas',
  'auth.info.editorAlt': 'informações do editor',
  'auth.info.feature.captions': 'Legendas geradas por IA',
  'auth.info.feature.dictionary': 'Dicionário de tradução',
  'auth.info.feature.languages': 'Tradução para mais de 135 idiomas',
  'auth.info.feature.lipSync': 'Lip-sync para adaptação de alto nível',
  'auth.info.feature.multiSpeaker': 'Dublagem com vários falantes',
  'auth.info.feature.voiceClone': 'Clonagem de voz em 32 idiomas',
  'auth.info.featuresTitleBottom': 'para resultados de alta qualidade',
  'auth.info.featuresTitleTop': 'Os melhores recursos',
  'auth.info.review.enterpriseRole': 'Mentora, Enterprise',

  'auth.info.review.enterpriseText': 'Ótima ferramenta para traduzir vídeos educacionais!',
  'auth.info.review.startupRole': 'Startup ',
  'auth.info.review.startupText': 'A melhor ferramenta para dublagem e tradução',
  'auth.info.scaleTitleBottom': 'em grande escala',
  'auth.info.scaleTitleTop': 'Tradução inteligente de vídeo',
  'auth.info.usersTitleBottom': 'em nossa IA de tradução de vídeo',
  'auth.info.usersTitleTop': 'Mais de 2 000 000 de usuários confiam',
  'auth.landing.createAccount': 'Crie uma conta grátis para traduzir sem custo.',
  'auth.landing.fileUploaded': 'Seu arquivo já foi enviado!',
  'auth.landing.hasAccount': 'Já tem uma conta?',
  'auth.landing.marketingConsent':
    'Enviaremos novidades do produto, dicas e ofertas da Rask.ai. Você pode deixar de receber essas mensagens a qualquer momento.',
  'auth.landing.orEmail': 'Ou cadastre-se com seu e-mail',
  'auth.landing.signIn': 'Entrar',
  'auth.landing.signUpFree': 'Cadastre-se grátis',
  'auth.landing.uploadComplete': 'Envio concluído',
  'auth.password.label': 'Senha',
  'auth.passwordResetNotice': 'Atualize sua senha. Enviamos um código de confirmação para o seu e-mail.',
  'auth.signin.forgotPassword': 'Esqueceu a senha?',
  'auth.signin.noAccount': 'Não tem uma conta?',
  'auth.signin.subtitle': 'Continue traduzindo vídeos 🤘',
  'auth.signin.title': 'Entrar',
  'auth.signup.landingSubtitle': 'Crie uma conta grátis para assistir.',
  'auth.signup.landingTitle': 'Seu vídeo traduzido está quase pronto!',
  'auth.signup.submit': 'Cadastrar-se',
  'auth.signup.subtitle': 'Junte-se a mais de 2 milhões de usuários e traduza qualquer vídeo com IA em minutos',
  'auth.signup.welcome': 'Bem-vindo',
  'auth.signup.welcomeRask': 'Bem-vindo à Rask AI',
  'auth.signupExperiment.adminEnabled': "Ativar experimento de cadastro",
  'auth.signupExperiment.brandTone': 'Consistência de marca e tom',
  'auth.signupExperiment.cleanSubtitle': 'Junte-se a mais de 4 milhões de usuários que traduzem vídeos com IA',
  'auth.signupExperiment.company': 'Está usando uma conta empresarial?',
  'auth.signupExperiment.createPassword': 'Crie uma senha',
  'auth.signupExperiment.emailSubmit': 'Cadastre-se com e-mail',
  'auth.signupExperiment.fiveStars': '5 de 5 estrelas',
  'auth.signupExperiment.languages': 'Mais de 135 idiomas',
  'auth.signupExperiment.noCard': 'Não é necessário cartão de crédito',
  'auth.signupExperiment.orEmail': 'ou com e-mail',
  'auth.signupExperiment.publishReady': 'Vídeos prontos para publicação',
  'auth.signupExperiment.rating': 'Avaliado com {rating} de 5 no G2',
  'auth.signupExperiment.reviewOne':
    '“Localizamos toda a nossa biblioteca de treinamento em 12 idiomas, e cada vídeo ainda tem a nossa identidade.”',
  'auth.signupExperiment.reviewTwo':
    '“A clonagem de voz me convenceu. Gravo uma vez e publico em quatro idiomas sem contratar quatro atores.”',
  'auth.signupExperiment.richTitle': 'Traduza seu primeiro vídeo',
  'auth.signupExperiment.roleOne': 'Líder de Operações de Conteúdo',
  'auth.signupExperiment.roleTwo': 'Especialista em T&D',
  'auth.signupExperiment.startFree': 'Comece grátis',
  'auth.signupExperiment.teams': 'Usado por equipes globais',
  'auth.signupExperiment.trustTitle': 'Mais de 4.000.000 de usuários confiam na Rask para localizar vídeos com IA',
  'auth.signupExperiment.voiceClone': 'Clonagem de voz',
  'auth.sso.back': 'Voltar',
  'auth.sso.continue': 'Continuar',
  'auth.sso.continueEmail': 'Continuar com e-mail e senha',
  'auth.sso.notConfigured': 'O SSO não está configurado para o seu e-mail',
  'auth.sso.signin': 'Entrar com SSO',
  'auth.sso.signup': 'Entrar com SSO',
  'auth.sso.subtitle': 'Use seu e-mail corporativo para entrar',
  'auth.sso.title': 'Continuar com SSO',
  'auth.terms.and': 'e os',
  'auth.terms.prefix': 'Ao se cadastrar, você concorda com a',
  'auth.terms.privacy': 'Política de Privacidade',
  'auth.terms.service': 'Termos de Serviço',
} satisfies AuthTranslation;

const fr = {
  'auth.change.newPasswordLabel': 'Nouveau mot de passe',
  'auth.change.newPasswordPlaceholder': 'Saisissez un nouveau mot de passe',
  'auth.change.subtitle': 'Définissez un nouveau mot de passe',
  'auth.change.title': 'Modifier le mot de passe',
  'auth.change.verificationCode': 'Code de vérification',
  'auth.code.label': 'Code',
  'auth.confirm.backSignup': 'Retour à l’inscription',
  'auth.confirm.resend': 'Renvoyer le code',
  'auth.confirm.resendFew': 'Renvoyer dans {count} secondes',
  'auth.confirm.resendMany': 'Renvoyer dans {count} secondes',
  'auth.confirm.resendOne': 'Renvoyer dans {count} seconde',
  'auth.confirm.resendOther': 'Renvoyer dans {count} secondes',
  'auth.confirm.submit': 'Confirmer l’adresse e-mail',
  'auth.confirm.subtitle':
    'Nous avons envoyé un e-mail contenant un code à {email}. Merci de le mettre ci-dessous pour confirmer votre compte.',
  'auth.confirm.title': 'Confirmez votre adresse e-mail',
  'auth.confirmationCodeSent': 'Un code de confirmation a été envoyé à votre adresse e-mail',
  'auth.email.label': 'Adresse e-mail',
  'auth.email.placeholder': 'Saisissez votre adresse e-mail',
  'auth.error.emailValidationFailed': 'Échec de la validation de l’adresse e-mail',
  'auth.error.incorrectEmail': 'Adresse e-mail incorrecte',
  'auth.error.incorrectPassword': 'Mot de passe incorrect',

  'auth.error.passwordTooShort': 'Au moins 6 caractères',
  'auth.error.somethingWentWrong': 'Une erreur est survenue',
  'auth.error.temporaryEmail': 'Utilisez une adresse e-mail non temporaire',
  'auth.forgot.backSignin': 'Retour à la connexion',
  'auth.forgot.confirm': 'Confirmer',
  'auth.forgot.subtitle':
    'Saisissez votre adresse e-mail et nous vous enverrons les instructions pour réinitialiser votre mot de passe.',
  'auth.forgot.title': 'Mot de passe oublié ?',
  'auth.google.signin': 'Se connecter avec Google',
  'auth.google.signup': 'Se connecter avec Google',
  'auth.info.achievementsAlt': 'informations sur les distinctions',
  'auth.info.editorAlt': 'informations sur l’éditeur',
  'auth.info.feature.captions': 'Sous-titres générés par l’IA',
  'auth.info.feature.dictionary': 'Dictionnaire de traduction',
  'auth.info.feature.languages': 'Traduction vers plus de 135 langues',
  'auth.info.feature.lipSync': 'Lip-sync pour une adaptation de premier ordre',
  'auth.info.feature.multiSpeaker': 'Doublage avec plusieurs intervenants',
  'auth.info.feature.voiceClone': 'Clonage vocal dans 32 langues',
  'auth.info.featuresTitleBottom': 'pour des résultats de haute qualité',
  'auth.info.featuresTitleTop': 'Les meilleures fonctionnalités',
  'auth.info.review.enterpriseRole': 'Mentore, Entreprise',

  'auth.info.review.enterpriseText': 'Un excellent outil pour traduire des vidéos éducatives !',
  'auth.info.review.startupRole': 'Startup ',
  'auth.info.review.startupText': 'Le meilleur outil de doublage et de traduction',
  'auth.info.scaleTitleBottom': 'à grande échelle',
  'auth.info.scaleTitleTop': 'Traduction vidéo intelligente',
  'auth.info.usersTitleBottom': 'à notre IA de traduction vidéo',
  'auth.info.usersTitleTop': 'Plus de 2 000 000 d’utilisateurs font confiance',
  'auth.landing.createAccount': 'Créez un compte gratuit pour le traduire gratuitement.',
  'auth.landing.fileUploaded': 'Votre fichier est déjà importé !',
  'auth.landing.hasAccount': 'Vous avez déjà un compte ?',
  'auth.landing.marketingConsent':
    'Nous vous enverrons des nouveautés produit, des conseils et des offres Rask.ai. Vous pouvez vous désabonner à tout moment.',
  'auth.landing.orEmail': 'Ou inscrivez-vous par e-mail',
  'auth.landing.signIn': 'Se connecter',
  'auth.landing.signUpFree': "S'inscrire gratuitement",
  'auth.landing.uploadComplete': 'Importation terminée',
  'auth.password.label': 'Mot de passe',
  'auth.passwordResetNotice':
    'Mettez votre mot de passe à jour. Nous avons envoyé un code de confirmation à votre adresse e-mail.',
  'auth.signin.forgotPassword': 'Mot de passe oublié ?',
  'auth.signin.noAccount': 'Vous n’avez pas de compte ?',
  'auth.signin.subtitle': 'Continuez à traduire vos vidéos 🤘',
  'auth.signin.title': 'Se connecter',
  'auth.signup.landingSubtitle': 'Créez un compte gratuit pour la regarder.',
  'auth.signup.landingTitle': 'Votre vidéo traduite est presque prête !',
  'auth.signup.submit': 'S’inscrire',
  'auth.signup.subtitle':
    'Rejoignez plus de 2 millions d’utilisateurs et traduisez toute vidéo avec l’IA en quelques minutes',
  'auth.signup.welcome': 'Bienvenue',
  'auth.signup.welcomeRask': 'Bienvenue sur Rask AI',
  'auth.signupExperiment.adminEnabled': "Activer l’expérience d’inscription",
  'auth.signupExperiment.brandTone': 'Cohérence de la marque et du ton',
  'auth.signupExperiment.cleanSubtitle':
    'Rejoignez plus de 4 millions d’utilisateurs qui traduisent leurs vidéos grâce à l’IA',
  'auth.signupExperiment.company': 'Vous utilisez un compte professionnel ?',
  'auth.signupExperiment.createPassword': 'Créez un mot de passe',
  'auth.signupExperiment.emailSubmit': 'S’inscrire avec une adresse e-mail',
  'auth.signupExperiment.fiveStars': '5 étoiles sur 5',
  'auth.signupExperiment.languages': 'Plus de 135 langues',
  'auth.signupExperiment.noCard': 'Aucune carte bancaire requise',
  'auth.signupExperiment.orEmail': 'ou avec une adresse e-mail',
  'auth.signupExperiment.publishReady': 'Vidéos prêtes à publier',
  'auth.signupExperiment.rating': 'Rask est noté {rating} sur 5 sur G2',
  'auth.signupExperiment.reviewOne':
    '« Nous adaptons toute notre bibliothèque de formation en 12 langues, et chaque vidéo reste fidèle à notre identité. »',
  'auth.signupExperiment.reviewTwo':
    '« Le clonage vocal m’a convaincu. J’enregistre une seule fois et je publie en quatre langues sans engager quatre comédiens. »',
  'auth.signupExperiment.richTitle': 'Traduisez votre première vidéo',
  'auth.signupExperiment.roleOne': 'Responsable des opérations de contenu',
  'auth.signupExperiment.roleTwo': 'Spécialiste L&D',
  'auth.signupExperiment.startFree': 'Commencer gratuitement',
  'auth.signupExperiment.teams': 'Utilisé par des équipes internationales',
  'auth.signupExperiment.trustTitle':
    'Plus de 4 000 000 d’utilisateurs font confiance à Rask pour adapter leurs vidéos avec l’IA',
  'auth.signupExperiment.voiceClone': 'Clonage vocal',
  'auth.sso.back': 'Retour',
  'auth.sso.continue': 'Continuer',
  'auth.sso.continueEmail': 'Continuer avec une adresse e-mail et un mot de passe',
  'auth.sso.notConfigured': 'Le SSO n’est pas configuré pour votre adresse e-mail',
  'auth.sso.signin': 'Se connecter avec le SSO',
  'auth.sso.signup': 'Se connecter avec le SSO',
  'auth.sso.subtitle': 'Utilisez votre adresse e-mail professionnelle pour vous connecter',
  'auth.sso.title': 'Continuer avec le SSO',
  'auth.terms.and': 'et les',
  'auth.terms.prefix': 'En vous inscrivant, vous acceptez la',
  'auth.terms.privacy': 'Politique de confidentialité',
  'auth.terms.service': "Conditions d'utilisation",
} satisfies AuthTranslation;

const it = {
  'auth.change.newPasswordLabel': 'Nuova password',
  'auth.change.newPasswordPlaceholder': 'Inserisci la nuova password',
  'auth.change.subtitle': 'Imposta una nuova password',
  'auth.change.title': 'Cambia password',
  'auth.change.verificationCode': 'Codice di verifica',
  'auth.code.label': 'Codice',
  'auth.confirm.backSignup': 'Torna alla registrazione',
  'auth.confirm.resend': 'Invia di nuovo il codice',
  'auth.confirm.resendFew': 'Invia di nuovo tra {count} secondi',
  'auth.confirm.resendMany': 'Invia di nuovo tra {count} secondi',
  'auth.confirm.resendOne': 'Invia di nuovo tra {count} secondo',
  'auth.confirm.resendOther': 'Invia di nuovo tra {count} secondi',
  'auth.confirm.submit': 'Conferma l’indirizzo e-mail',
  'auth.confirm.subtitle':
    'Abbiamo inviato un’e-mail con un codice a {email}. Copia il codice dall’e-mail e incollalo nel modulo per confermare il tuo account.',
  'auth.confirm.title': 'Conferma il tuo indirizzo e-mail',
  'auth.confirmationCodeSent': 'Abbiamo inviato un codice di conferma al tuo indirizzo e-mail',
  'auth.email.label': 'E-mail',
  'auth.email.placeholder': 'Inserisci il tuo indirizzo e-mail',
  'auth.error.emailValidationFailed': 'Convalida dell’indirizzo e-mail non riuscita',
  'auth.error.incorrectEmail': 'Indirizzo e-mail non corretto',
  'auth.error.incorrectPassword': 'Password non corretta',

  'auth.error.passwordTooShort': 'Almeno 6 caratteri',
  'auth.error.somethingWentWrong': 'Qualcosa è andato storto',
  'auth.error.temporaryEmail': 'Usa un indirizzo e-mail non temporaneo',
  'auth.forgot.backSignin': 'Torna all’accesso',
  'auth.forgot.confirm': 'Conferma',
  'auth.forgot.subtitle': 'Inserisci il tuo indirizzo e-mail e ti invieremo le istruzioni per reimpostare la password.',
  'auth.forgot.title': 'Hai dimenticato la password?',
  'auth.google.signin': 'Accedi con Google',
  'auth.google.signup': 'Accedi con Google',
  'auth.info.achievementsAlt': 'informazioni sui riconoscimenti',
  'auth.info.editorAlt': 'informazioni sull’editor',
  'auth.info.feature.captions': 'Sottotitoli generati dall’IA',
  'auth.info.feature.dictionary': 'Dizionario di traduzione',
  'auth.info.feature.languages': 'Traduzione in oltre 135 lingue',
  'auth.info.feature.lipSync': 'Sincronizzazione labiale per una localizzazione di alto livello',
  'auth.info.feature.multiSpeaker': 'Doppiaggio con più parlanti',
  'auth.info.feature.voiceClone': 'Clonazione vocale in 32 lingue',
  'auth.info.featuresTitleBottom': 'per risultati di alta qualità',
  'auth.info.featuresTitleTop': 'Le migliori funzionalità',
  'auth.info.review.enterpriseRole': 'Mentor, Enterprise',
  'auth.info.review.enterpriseText': 'Un ottimo strumento per tradurre video didattici!',
  'auth.info.review.startupRole': 'Startup ',
  'auth.info.review.startupText': 'Il miglior strumento per doppiare e tradurre',
  'auth.info.scaleTitleBottom': 'su larga scala',
  'auth.info.scaleTitleTop': 'Traduzione video intelligente',
  'auth.info.usersTitleBottom': 'della nostra IA per la traduzione video',
  'auth.info.usersTitleTop': 'Più di 2 000 000 di utenti si fidano',
  'auth.landing.createAccount': 'Crea un account gratuito per tradurlo gratis.',
  'auth.landing.fileUploaded': 'Il tuo file è già stato caricato!',
  'auth.landing.hasAccount': 'Hai già un account?',
  'auth.landing.marketingConsent':
    'Ti invieremo aggiornamenti sul prodotto, consigli e offerte di Rask.ai. Puoi annullare l’iscrizione in qualsiasi momento.',
  'auth.landing.orEmail': 'Oppure registrati con la tua e-mail',
  'auth.landing.signIn': 'Accedi',
  'auth.landing.signUpFree': 'Registrati gratis',
  'auth.landing.uploadComplete': 'Caricamento completato',
  'auth.password.label': 'Password',
  'auth.passwordResetNotice': 'Aggiorna la password. Abbiamo inviato un codice di conferma al tuo indirizzo e-mail.',
  'auth.signin.forgotPassword': 'Hai dimenticato la password?',
  'auth.signin.noAccount': 'Non hai un account?',
  'auth.signin.subtitle': 'Continua a tradurre video 🤘',
  'auth.signin.title': 'Accedi',
  'auth.signup.landingSubtitle': 'Crea un account gratuito per guardarlo.',
  'auth.signup.landingTitle': 'Il tuo video tradotto è quasi pronto!',
  'auth.signup.submit': 'Registrati',
  'auth.signup.subtitle': 'Unisciti a oltre 2 milioni di utenti e traduci qualsiasi video con l’IA in pochi minuti',
  'auth.signup.welcome': 'Ti diamo il benvenuto',
  'auth.signup.welcomeRask': 'Ti diamo il benvenuto su Rask AI',
  'auth.signupExperiment.adminEnabled': 'Enable signup experiment',
  'auth.signupExperiment.brandTone': 'Consistent brand & tone',
  'auth.signupExperiment.cleanSubtitle': 'Join 4M+ users translating videos with AI',
  'auth.signupExperiment.company': 'Using a company account?',
  'auth.signupExperiment.createPassword': 'Create password',
  'auth.signupExperiment.emailSubmit': 'Sign up with email',
  'auth.signupExperiment.fiveStars': '5 out of 5 stars',
  'auth.signupExperiment.languages': '135+ languages',
  'auth.signupExperiment.noCard': 'No credit card required',
  'auth.signupExperiment.orEmail': 'or with email',
  'auth.signupExperiment.publishReady': 'Publish-ready videos',
  'auth.signupExperiment.rating': 'Rated {rating} out of 5 on G2',
  'auth.signupExperiment.reviewOne':
    '“We localize our entire training library into 12 languages, and every video still sounds like us.”',
  'auth.signupExperiment.reviewTwo':
    '“The voice clone sold it. I record once and publish in four languages without hiring four actors.”',
  'auth.signupExperiment.richTitle': 'Translate Your First Video',
  'auth.signupExperiment.roleOne': 'Head of Content Operations',
  'auth.signupExperiment.roleTwo': 'L&D Specialist',
  'auth.signupExperiment.startFree': 'Start free',
  'auth.signupExperiment.teams': 'Used by global teams',
  'auth.signupExperiment.trustTitle': '4,000,000+ Users Trust Rask with AI Video Localization',
  'auth.signupExperiment.voiceClone': 'Voice clone',
  'auth.sso.back': 'Indietro',
  'auth.sso.continue': 'Continua',
  'auth.sso.continueEmail': 'Continua con e-mail e password',
  'auth.sso.notConfigured': 'L’SSO non è configurato per il tuo indirizzo e-mail',
  'auth.sso.signin': 'Accedi con SSO',
  'auth.sso.signup': 'Accedi con SSO',
  'auth.sso.subtitle': 'Usa l’e-mail aziendale per accedere',
  'auth.sso.title': 'Continua con l’SSO',
  'auth.terms.and': 'e i',
  'auth.terms.prefix': 'Registrandoti, accetti',
  'auth.terms.privacy': 'l’Informativa sulla privacy',
  'auth.terms.service': 'Termini di servizio',
} satisfies AuthTranslation;

const ru = {
  'auth.change.newPasswordLabel': 'Новый пароль',
  'auth.change.newPasswordPlaceholder': 'Введите новый пароль',
  'auth.change.subtitle': 'Установите новый пароль',
  'auth.change.title': 'Изменение пароля',
  'auth.change.verificationCode': 'Код подтверждения',
  'auth.code.label': 'Код',
  'auth.confirm.backSignup': 'Вернуться к регистрации',
  'auth.confirm.resend': 'Отправить код повторно',
  'auth.confirm.resendFew': 'Повторная отправка через {count} секунды',
  'auth.confirm.resendMany': 'Повторная отправка через {count} секунд',
  'auth.confirm.resendOne': 'Повторная отправка через {count} секунду',
  'auth.confirm.resendOther': 'Повторная отправка через {count} секунды',
  'auth.confirm.submit': 'Подтвердить электронную почту',
  'auth.confirm.subtitle':
    'Мы отправили письмо с кодом на адрес {email}. Скопируйте код из письма и вставьте его в форму, чтобы подтвердить аккаунт.',
  'auth.confirm.title': 'Подтвердите электронную почту',
  'auth.confirmationCodeSent': 'Код подтверждения отправлен на вашу электронную почту',
  'auth.email.label': 'Электронная почта',
  'auth.email.placeholder': 'Введите электронную почту',
  'auth.error.emailValidationFailed': 'Не удалось проверить электронную почту',
  'auth.error.incorrectEmail': 'Неверный адрес электронной почты',
  'auth.error.incorrectPassword': 'Неверный пароль',

  'auth.error.passwordTooShort': 'Минимум 6 символов',
  'auth.error.somethingWentWrong': 'Что-то пошло не так',
  'auth.error.temporaryEmail': 'Используйте постоянный адрес электронной почты',
  'auth.forgot.backSignin': 'Вернуться к форме входа',
  'auth.forgot.confirm': 'Подтвердить',
  'auth.forgot.subtitle': 'Введите электронную почту, и мы отправим инструкции по сбросу пароля.',
  'auth.forgot.title': 'Забыли пароль?',
  'auth.google.signin': 'Войти через Google',
  'auth.google.signup': 'Войти через Google',
  'auth.info.achievementsAlt': 'Награды и рейтинги Rask AI',
  'auth.info.editorAlt': 'Интерфейс видеоредактора Rask AI',
  'auth.info.feature.captions': 'Субтитры, созданные ИИ',
  'auth.info.feature.dictionary': 'Словарь переводов',
  'auth.info.feature.languages': 'Перевод на 135+ языков',
  'auth.info.feature.lipSync': 'Липсинк для локализации высшего уровня',
  'auth.info.feature.multiSpeaker': 'Дубляж с несколькими спикерами',
  'auth.info.feature.voiceClone': 'Voice Clone на 32 языках',
  'auth.info.featuresTitleBottom': 'для качественного результата',
  'auth.info.featuresTitleTop': 'Лучшие возможности',
  'auth.info.review.enterpriseRole': 'Ментор, Enterprise',

  'auth.info.review.enterpriseText': 'Отличный инструмент для перевода образовательных видео!',
  'auth.info.review.startupRole': 'Стартап ',
  'auth.info.review.startupText': 'Лучший инструмент для дубляжа и перевода',
  'auth.info.scaleTitleBottom': 'в любом масштабе',
  'auth.info.scaleTitleTop': 'Умный перевод видео',
  'auth.info.usersTitleBottom': 'нашему ИИ для перевода видео',
  'auth.info.usersTitleTop': 'Более 2 000 000 пользователей доверяют',
  'auth.landing.createAccount': 'Создайте бесплатный аккаунт, чтобы перевести его бесплатно.',
  'auth.landing.fileUploaded': 'Ваш файл уже загружен!',
  'auth.landing.hasAccount': 'Уже есть аккаунт?',
  'auth.landing.marketingConsent':
    'Мы будем присылать новости о продукте, советы и предложения Rask.ai. От рассылки можно отказаться в любое время.',
  'auth.landing.orEmail': 'Или зарегистрируйтесь по электронной почте',
  'auth.landing.signIn': 'Войти',
  'auth.landing.signUpFree': 'Зарегистрироваться бесплатно',
  'auth.landing.uploadComplete': 'Загрузка завершена',
  'auth.password.label': 'Пароль',
  'auth.passwordResetNotice': 'Обновите пароль. Мы отправили код подтверждения на вашу электронную почту.',
  'auth.signin.forgotPassword': 'Забыли пароль?',
  'auth.signin.noAccount': 'Нет аккаунта?',
  'auth.signin.subtitle': 'Продолжайте переводить видео 🤘',
  'auth.signin.title': 'Войти',
  'auth.signup.landingSubtitle': 'Создайте бесплатный аккаунт, чтобы посмотреть видео.',
  'auth.signup.landingTitle': 'Ваше переведённое видео почти готово!',
  'auth.signup.submit': 'Зарегистрироваться',
  'auth.signup.subtitle':
    'Присоединяйтесь к более чем 2 млн пользователей и переводите видео с помощью ИИ за считанные минуты',
  'auth.signup.welcome': 'Добро пожаловать',
  'auth.signup.welcomeRask': 'Добро пожаловать в Rask AI',
  'auth.signupExperiment.adminEnabled': "Включить эксперимент при регистрации",
  'auth.signupExperiment.brandTone': 'Единый стиль и тон бренда',
  'auth.signupExperiment.cleanSubtitle': 'Присоединяйтесь к более чем 4 миллионам пользователей, которые переводят видео с помощью ИИ',
  'auth.signupExperiment.company': 'Используете корпоративный аккаунт?',
  'auth.signupExperiment.createPassword': 'Создайте пароль',
  'auth.signupExperiment.emailSubmit': 'Зарегистрироваться по почте',
  'auth.signupExperiment.fiveStars': '5 из 5 звёзд',
  'auth.signupExperiment.languages': 'Более 135 языков',
  'auth.signupExperiment.noCard': 'Банковская карта не требуется',
  'auth.signupExperiment.orEmail': 'или по электронной почте',
  'auth.signupExperiment.publishReady': 'Видео, готовые к публикации',
  'auth.signupExperiment.rating': 'Оценка {rating} из 5 на G2',
  'auth.signupExperiment.reviewOne':
    '«Мы локализуем всю нашу библиотеку обучающих материалов на 12 языков — и каждое видео по-прежнему звучит по-нашему».',
  'auth.signupExperiment.reviewTwo':
    '«Клонирование голоса меня убедило. Я записываю видео один раз и публикую его на четырёх языках, не нанимая четырёх актёров».',
  'auth.signupExperiment.richTitle': 'Переведите своё первое видео',
  'auth.signupExperiment.roleOne': 'Руководитель отдела управления контентом',
  'auth.signupExperiment.roleTwo': 'Специалист по обучению и развитию',
  'auth.signupExperiment.startFree': 'Начать бесплатно',
  'auth.signupExperiment.teams': 'Используется международными командами',
  'auth.signupExperiment.trustTitle': 'Более 4 000 000 пользователей доверяют Rask локализацию видео с помощью ИИ',
  'auth.signupExperiment.voiceClone': 'Клонирование голоса',
  'auth.sso.back': 'Назад',
  'auth.sso.continue': 'Продолжить',
  'auth.sso.continueEmail': 'Продолжить с помощью электронной почты и пароля',
  'auth.sso.notConfigured': 'Для вашего адреса электронной почты не настроен SSO',
  'auth.sso.signin': 'Войти через SSO',
  'auth.sso.signup': 'Войти через SSO',
  'auth.sso.subtitle': 'Используйте корпоративную электронную почту для входа',
  'auth.sso.title': 'Продолжить через SSO',
  'auth.terms.and': 'и',
  'auth.terms.prefix': 'Регистрируясь, вы принимаете',
  'auth.terms.privacy': 'Политику конфиденциальности',
  'auth.terms.service': 'Условия использования',
} satisfies AuthTranslation;

export const AUTH_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });

export type AuthTranslationKey = keyof typeof en;
